module.exports = __webpack_public_path__ + "static/icon_gic.95e39488.png";